import Swiper, { EffectFade, Autoplay } from 'swiper';

export default (sliderNode) => {
  if (!sliderNode) {
    return false;
  }

  new Swiper(sliderNode, {
    modules: [EffectFade, Autoplay],
    effect: 'fade',
    loop: true,
    autoplay: {
      disableOnInteraction: false,
    },
    allowTouchMove: false,
  });

  return true;
};
